module.exports = __webpack_public_path__ + "assets/img/宣品严选.5883556a.png";